import { createSlice } from '@reduxjs/toolkit';
import { fetchChart1Data, fetchChart2Data, fetchChart3Data, fetchChart4Data, fetchChart5Data, fetchChart6Data, fetchChart7Data, fetchChart8Data, fetchChart9Data } from "../services/operations/videoPerformanceApi";
import { fetchVideoPerformanceKPIData } from "../services/operations/videoPerformanceApi";

const initialState = {
    globalFilters: {
        selectedDays: 'Last 28 days',
        selectedChannel: 'All Channels',
        selectedTable: '',
    },
    chartsData: {
        chart1: { data: null, loading: false, error: null },
        chart2: { data: null, loading: false, error: null },
        chart3: { data: null, loading: false, error: null },
        chart4: { data: null, loading: false, error: null },
        chart5: { data: null, loading: false, error: null },
        chart6: { data: null, loading: false, error: null },
        chart7: { data: null, loading: false, error: null },
        chart8: { data: null, loading: false, error: null },
        chart9: { data: null, loading: false, error: null },
    },
    videoFilters: {
        chart1: [],
        chart2: [],
        chart3: [],
        chart4: [],
        chart5: [],
        chart6: [],
        chart7: [],
        chart8: [],
        chart9: [],
    },
    loading: false,
    error: null,
    videoPerformaceKpiData: []
};
const analyticsSlice = createSlice({

    name: 'analytics',
    initialState,

    reducers: {
        setGlobalFilters(state, action) {
            state.globalFilters = { ...state.globalFilters, ...action.payload };
        },
        clearChartData(state) {
            state.chartsData = initialState.chartsData;
            state.videoFilters = initialState.videoFilters;
        },
        // setVideoFilter(state, action) {
        //     const { chartId, selectedTitles } = action.payload;
        //     state.videoFilters[chartId] = selectedTitles;
        // },
    },

    extraReducers: (builder) => {

        // List of chart actions and their corresponding state keys
        const charts = [
            { action: fetchChart1Data, key: 'chart1' },
            { action: fetchChart2Data, key: 'chart2' },
            { action: fetchChart3Data, key: 'chart3' },
            { action: fetchChart4Data, key: 'chart4' },
            { action: fetchChart5Data, key: 'chart5' },
            { action: fetchChart6Data, key: 'chart6' },
            { action: fetchChart7Data, key: 'chart7' },
            { action: fetchChart8Data, key: 'chart8' },
            { action: fetchChart9Data, key: 'chart9' },
        ]

        charts.forEach(({ action, key }) => {
            builder.addCase(action.pending, (state) => {
                state.chartsData[key].loading = true;
                state.chartsData[key].error = null;
            });
            builder.addCase(action.fulfilled, (state, action) => {
                state.chartsData[key].loading = false;
                state.chartsData[key].data = action.payload;
                state.chartsData[key].error = null;
            });
            builder.addCase(action.rejected, (state, action) => {
                state.chartsData[key].loading = false;
                state.chartsData[key].error = action.payload;
            });
        })

        // builder
        //     .addCase(fetchVideoPerformanceKPIData.pending, (state) => {
        //         state.loading = true;
        //         state.error = null;
        //     })
        //     .addCase(fetchVideoPerformanceKPIData.fulfilled, (state, action) => {
        //         state.loading = false;
        //         state.videoPerformaceKpiData = action.payload;
        //     })
        //     .addCase(fetchVideoPerformanceKPIData.rejected, (state, action) => {
        //         state.loading = false;
        //         state.error = action.payload;
        //     });

    }
})

export const { setGlobalFilters, setVideoFilter, clearChartData } = analyticsSlice.actions;
export default analyticsSlice.reducer;